import styled from 'styled-components'

import '@fontsource/plus-jakarta-sans'

export const CardsContainer = styled.div<{ $showCoursesDetails?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: ${(props) => (props.$showCoursesDetails ? '0px' : '20px')};
`

export const CardContainer = styled.div<{ $showCoursesDetails?: boolean }>`
  width: 286px;
  height: fit-content;
  padding: ${(props) =>
    props.$showCoursesDetails ? '8px 8px 15px 8px' : '8px 8px 31px 8px'};
  border-radius: 10px;
  background: #f6f6f6;

  margin-right: 16px;
  position: relative;
`

export const CardsCoachContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 24px;
  column-gap: 39px;
  width: 100%;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`
export const CardContainerCoach = styled.div`
  width: calc(50% - 19.5px);
  /* width: 100%; */
  padding: 9px 8px;
  display: flex;
  gap: 32px;
  /* box-shadow: 0px 4px 8px 0px rgba(142, 146, 188, 0.5); */
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  justify-content: space-between;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    width: 100%;
    gap: 0px;
  }
`
export const CardCouchDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: calc(100% - 148px);

  @media screen and (max-width: 768px) {
    width: calc(100% - 86px);
  }
`

export const ImageRutine = styled.div`
  width: 270px;
  height: 94px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  margin-bottom: 8px;
`

export const ImageCoach = styled.div`
  width: 116px;
  height: 121px;
  border-radius: 10px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  @media screen and (max-width: 768px) {
    width: 78px;
    height: 81px;
  }
`

export const CoachTags = styled.div`
  display: flex;
  gap: 2px;
  row-gap: 4px;
  flex-wrap: wrap;

  .tag {
    background-color: #bdddeb;
    padding: 4px 8px;
    border-radius: 10px;

    p {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.12px;
      color: #0a0a18;
    }
  }
`
export const CardCoachText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;

  .title {
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: -0.02em;
    color: #030410;
  }

  .subtitle {
    p {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: -0.24px;
      color: #0a0a18;
    }
  }
  .description {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: #54577a;
  }
`

export const CoachBio = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  .bio-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: #030410;
  }
`

export const CardRutineText = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 10px;

  .title {
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.24px;
    color: #0a0a18;
  }

  .description {
    margin-top: 12px;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    text-align: left;
    letter-spacing: -0.02em;
    color: #54577a;
  }
`

export const CarouselButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 20px;

  .title {
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
    display: flex;
    align-items: center;
    letter-spacing: -0.03em;
    color: #030410;
  }

  .carousel-arrows {
    position: relative;
    color: #030410;
    width: 80px;
    height: 24px;
    display: flex;
    align-items: center;

    button {
      width: 24px;
      height: 24px;
      border: none;
      display: flex;
      align-items: center;
      background: transparent;
      margin: 0 14px;
      cursor: pointer;

      &:focus {
        outline: none;
      }
      span {
        color: #030410;
        width: 25px;
        height: 24px;
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
`

export const CardEdition = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  .editionButton {
    cursor: pointer;
    padding-right: 16px;
    &:last-child {
      padding-right: 0;
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
`
export const ChallengeCard = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  padding: 16px;
  display: flex;
  flex-direction: column;
  width: calc(33% - 5px);

  .hashtags {
    color: #7a8b94;
    font-size: 14px;
  }

  .action {
    background: #08a8d2;
    border: none;
    color: #fff;
    border-radius: 12px;
    padding: 8px 12px;
    margin-top: auto;
    cursor: pointer;

    &.delete {
      background: #f44336;
    }
  }

  .actions-container {
    display: flex;
    justify-content: space-between;
    gap: 10px;

    .action {
      width: 50%;
    }
  }

  @media screen and (max-width: 1024px) {
    width: calc(50% - 5px);
  }

  @media screen and (max-width: 700px) {
    width: 100%;
  }
`

export const ChallengeImage = styled.img`
  border-radius: 12px;
  height: 160px;
  object-fit: cover;
  margin-bottom: 10px;
`
